import styled from 'styled-components';
import { Select } from 'antd';

export const StyledSelect = styled(Select)`
  width: 100%;
  display: block;
  margin-top: ${({ theme }) => theme.spacing.space_2};

  .ant-select-selector {
    min-height: ${({ theme }) => theme.spacing.space_5} !important;
    height: auto !important;
  }
`;
